import {Keys} from '../enums';

export const INPUT_CONTROL_USER_INTERACTION_KEYS: Array<string> = [Keys.Enter, Keys.Tab, Keys.Space, Keys.Coma, Keys.Semicolon, Keys.IESpace];
